
export default class Utility {
    static zeroFront(value:number){
        if(value<10)
        {
            return '0' + value;
        }
        else
        return value;
    }
    
    static ClearId(id:string){
        return id.split('/')[2];
    }

    static toPlaintext(delta) {
        return delta.reduce(function (text, op) {
          if (!op.insert) throw new TypeError('only `insert` operations can be transformed!');
          if (typeof op.insert !== 'string') return text + ' ';
          return text + op.insert;
        }, '');
      };

     public static getHTML(d:string){
		if(d)
		return JSON.parse(d).HTML;
	}

}